(function () {

    // get anchor which could be clicked for the current site
    var anchorList = $('a', '.footer').filter(function (item) {
        // keep the fragment since it can make pages look completly different
        var currentPath = location.href.replace(location.origin, '').toLowerCase(),
            currentHref = (this.href || '').replace(location.origin, '').toLowerCase();

        return currentHref === currentPath;
    });

    // mark them as selected
    anchorList.addClass('selected');

})();